import { deleteLocalStorageAndCookies } from '@/utils/localStorage'
import { HOME_PAGE } from '@/utils/constants'
import { FE_AUTH_LOGOUT_API } from '@/helper/apiConstants'

// Canonical "session is invalid" cleanup: tell the backend (best-effort), clear all local client state, then hard-redirect so every component remounts with genuinely reset state.
export const forceCleanLogout = async (abcAxis?: string) => {
  try {
    await fetch(FE_AUTH_LOGOUT_API, {
      method: 'POST',
      headers: { abcAxis: abcAxis || '' },
    })
  } catch {
    // best-effort - proceed with client-side cleanup regardless
  }
  await deleteLocalStorageAndCookies()
  if (typeof window !== 'undefined') {
    window.location.replace(HOME_PAGE)
  }
}
